import React, { Component, Fragment } from 'react';

export default class Wrapper extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="col">
                    {this.props.children}
                </div>
                <hr />
                <div className="row">
                    <h5 className="text-center">{this.popdescripcion}</h5>
                </div>
            </Fragment>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/home/children/wrapper.jsx